var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.453629,
    width: 59.0927,
    height: 59.0927,
    rx: 17.3802,
    fill: "#C17B31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_239_61)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.4457 11.2971H21.633C15.5062 11.2971 12.0349 14.7684 12.0349 20.8952V37.6919C12.0349 43.8187 15.5062 47.29 21.633 47.29H38.4457C44.5725 47.29 48.0278 43.8187 48.0278 37.6919V20.8952C48.0278 14.7684 44.5725 11.2971 38.4457 11.2971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_239_61)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_239_61)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7127 19.3197L38.7669 19.2558C39.2158 19.2542 39.6607 19.3448 40.0759 19.5226C40.4911 19.7003 40.8685 19.9616 41.1865 20.2915C41.5045 20.6214 41.7568 21.0135 41.9289 21.4451C42.1011 21.8768 42.1897 22.3396 42.1897 22.807V31.6883C42.1897 32.6301 41.8303 33.5334 41.1907 34.1994C40.551 34.8653 39.6835 35.2395 38.7789 35.2395H21.7247C20.8201 35.2395 19.9525 34.8653 19.3129 34.1994C18.6732 33.5334 18.3138 32.6301 18.3138 31.6883V22.8709C18.3138 21.9312 18.6716 21.0298 19.3086 20.3642C19.9457 19.6986 20.8102 19.323 21.7127 19.3197Z",
    stroke: "white",
    strokeWidth: 2.17053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6062 26.5392L29.0578 22.9881C28.9312 22.8892 28.7805 22.8289 28.6228 22.8141C28.4651 22.7993 28.3065 22.8305 28.1649 22.9043C28.0232 22.978 27.9041 23.0913 27.8209 23.2316C27.7376 23.3718 27.6935 23.5335 27.6935 23.6983V30.8006C27.6935 30.9655 27.7376 31.1271 27.8209 31.2673C27.9041 31.4076 28.0232 31.5209 28.1649 31.5946C28.3065 31.6684 28.4651 31.6996 28.6228 31.6848C28.7805 31.67 28.9312 31.6097 29.0578 31.5108L33.6062 27.9597C33.7121 27.877 33.7981 27.7698 33.8573 27.6465C33.9165 27.5232 33.9473 27.3873 33.9473 27.2495C33.9473 27.1116 33.9165 26.9757 33.8573 26.8524C33.7981 26.7292 33.7121 26.6219 33.6062 26.5392Z",
    fill: "#C17B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6634 38.7906H38.779",
    stroke: "white",
    strokeWidth: 2.17053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4985,
    height: 36.4985,
    fill: "white",
    transform: "translate(11.7506 11.2971)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_239_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0464,
    height: 26.0464,
    fill: "white",
    transform: "translate(17.4999 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_239_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0464,
    height: 26.0464,
    fill: "white",
    transform: "translate(17.4999 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/Tv.4d2a6c32a9ae2f6b74a56dde1b4cb698.svg";
export { ForwardRef as ReactComponent };